import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import { FC } from "react";
import { twMerge } from "tailwind-merge";

interface CircleTextProps {
  text: string;
}

const CircleText: FC<CircleTextProps> = ({ text }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={twMerge("flex h-12 w-12 items-center justify-center rounded-full", theme.circleText.background)}>
      <span className={twMerge("font-bold", theme.circleText.text)}>{text}</span>
    </div>
  );
};

export default CircleText;
